(function(TIPTOE, window, d, $) {
  // Variables
  var $popIn = $('#js-pop-in-cart');
  var $productInfo = $('.product-info__readmore');

  $(document).ready(function() {
    // Cart recap when adding product to cart
    $(document.body).on('added_to_cart', function(e, data) {
      TweenLite.to($popIn, 1, { autoAlpha: 1, ease: Expo.easeOut });

      // Small delay to bind events to the repopulated data
      setTimeout(function() {
        $('.js-close-pop-in').click(function() {
          TweenLite.to($popIn, 1, { autoAlpha: 0, ease: Expo.easeOut });
        });
      }, 200);

      $('.js--add_to_cart').removeClass('is-adding');
    });
  });

  if ($productInfo.length) {
    $productInfo.on('click', function(event) {
      event.preventDefault();
      $('.product-info').toggleClass('product-info--open');
    });
  }

  // GOOGLE analytics stuff
  $('.wl-add-to-single').on('click', function(e) {
    if (e.isDefaultPrevented() || typeof ga !== 'function') return;

    // Ajout a wishlist
    if ($(this).data('listid') != 'session') {
      ga(
        'send',
        'event',
        'Intention_Achat',
        'Ajout_Wishlist',
        'Produit_Ajoute_Wishlist'
      );
    }
  });
})(TIPTOE, window, document, jQuery);
